import React from 'react';
import { ContentNote } from './ContentNote';
interface SportHeroProps {
  title: string;
  intro: string;
  image: string;
  imageAlt: string;
  ctaLabel: string;
  onCta: () => void;
  showNote?: boolean;
}
export function SportHero({
  title,
  intro,
  image,
  imageAlt,
  ctaLabel,
  onCta,
  showNote = true
}: SportHeroProps) {
  return <section aria-labelledby="page-title" className="relative h-[460px] overflow-hidden bg-brand-navy md:h-[420px]" data-id="element-225" data-mp="xur34x3tjknn">
      <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" data-id="element-226" data-mp="a2keyl88yjzb" />
      <div className="absolute inset-0 bg-black/45" aria-hidden="true" data-id="element-227" data-mp="53h76t0vtznn" />
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 pb-20 text-center md:pb-24" data-id="element-228" data-mp="jv87v4w3w3sr">
        <h1 id="page-title" className="max-w-4xl font-display text-[40px] font-bold italic leading-[0.95] text-white [text-shadow:0_3px_10px_rgba(0,0,0,0.45)] md:text-[64px]" data-id="element-229" data-mp="f2f52mk775jb">
          {title}
        </h1>
        <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-white md:text-base" data-id="element-230" data-mp="1vf8ay3ubcsp8">{intro}</p>
        <button type="button" onClick={onCta} className="mt-6 rounded-sm bg-brand-red px-7 py-3 text-sm font-semibold text-white shadow-md transition-colors duration-150 hover:bg-brand-redDark focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-red" data-id="element-231" data-mp="20dtfgfgllyjh">
          {ctaLabel}
        </button>
      </div>
      <svg className="absolute bottom-0 left-0 z-10 h-16 w-full md:h-24" viewBox="0 0 1200 120" preserveAspectRatio="none" aria-hidden="true" data-id="element-232" data-mp="1hep9jfkcskw1">
        <path d="M0,22 Q600,150 1200,22 L1200,120 L0,120Z" fill="#ffffff" data-id="element-233" data-mp="1lfhf9yu0o7nk" />
        <path d="M0,30 Q600,155 1200,30 L1200,120 L0,120Z" fill="#2F9BE0" data-id="element-234" data-mp="1qgoom2bt5ewc" />
        <path d="M0,56 Q600,165 1200,56 L1200,120 L0,120Z" fill="#ffffff" data-id="element-235" data-mp="2wwh8cwo6uqin" />
        <path d="M0,62 Q600,170 1200,62 L1200,120 L0,120Z" fill="#E8312F" data-id="element-236" data-mp="31v270rnsl24z" />
        <path d="M0,88 Q600,182 1200,88 L1200,120 L0,120Z" fill="#1C2369" data-id="element-237" data-mp="31x58c7ueahp0" />
      </svg>
      {showNote && <ContentNote kind="hybrid" detail="H1/intro use {city} + {sport} tokens. Image is a per-sport field." data-id="element-238" data-mp="11uvyqlbdgh6l" />}
    </section>;
}